module.exports = __webpack_public_path__ + "static/media/multiusuario.0231536d.svg";